import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

function canPopHistory() {
    const index = window.history.state?.idx;
    return typeof index === 'number' && index > 0;
}

export function useListBackNavigation(fallbackPath) {
    const navigate = useNavigate();

    const goBack = useCallback(() => {
        if (canPopHistory()) {
            navigate(-1);
            return;
        }
        if (fallbackPath) {
            navigate(fallbackPath, { replace: true });
        }
    }, [fallbackPath, navigate]);

    const goToList = useCallback(() => {
        if (fallbackPath) {
            navigate(fallbackPath);
        }
    }, [fallbackPath, navigate]);

    return { goBack, goToList };
}
